
        const symbolId = 'x';
        const symbolUrl = '/build/app/img/symbols.svg#' + symbolId;
        
        export default {
            id: symbolId,
            url: symbolUrl,
            viewBox: undefined,
            toString: function() {
                return this.url;
            }
        };
        
        export const url = symbolUrl;
        export const id = symbolId;
    